import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class LoginService {
    private apiUrl = `${environment.apiUrl}/login`;

    constructor(private http: HttpClient, private router: Router) { }


    loginWithPassword(email: string, password: string): Observable<any> {

        const raw = JSON.stringify({ email, password });

        return this.http.post(this.apiUrl, raw, {
            headers: { 'Content-Type': 'application/json' },  // Adicionando o cabeçalho Content-Type
            observe: 'response'
            }).pipe(
                map(response => {
                    if (response.status !== 200) {
                        throw new Error('Erro ao imprimir etiquetas');
                    }
                    return response.body;
                })
            );
    }

    loginWithSellerId(sellerId: number): Observable<any> {
        const query = `?code=&sellerId=${sellerId}`;
        return this.http.get<any>(`${this.apiUrl}${query}`, {
            observe: 'response'
        }).pipe(
            map(response => {
                if (response.status !== 200) {
                    throw new Error('Erro ao fazer login com sellerId');
                }
                return response.body;
            })
        );
    }
}
